import { Injectable } from '@angular/core';
import {
  hydrateSessionOnStartup,
  persistSessionToLocalStorage,
  clearPersistedSession,
} from '../shared/session-cookie.util';

/**
 * Wrapper fino sobre as funções puras de sessão (session-cookie.util). A hidratação de fato
 * roda no main.ts (antes do Angular subir); aqui expomos persist()/clear() para os fluxos de
 * auth (login/refresh/logout). bootstrap() é mantido por compatibilidade.
 */
@Injectable({ providedIn: 'root' })
export class SessionPersistenceService {
  bootstrap(): void { hydrateSessionOnStartup(); }
  persist(): void { persistSessionToLocalStorage(); }
  clear(): void { clearPersistedSession(); }
}
